// extracted by mini-css-extract-plugin
export default {"value":"WSCardHeaderValue-module_value-IyW6o"};